module.exports = __webpack_public_path__ + "static/media/microscopy-nsit0108-01 4.80d86782.png";